import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const Card = ({ to, title, emoji, description }) => (
  <Link
    to={to}
    className="bg-white shadow-sm rounded-2xl p-6 hover:shadow-xl transform transition duration-300 block"
    aria-label={title}
    data-aos="fade-up"
    data-aos-duration="800"
  >
    <h2 className="text-xl font-semibold text-blue-700">
      {emoji} {title}
    </h2>
    <p className="mt-2 text-gray-600">{description}</p>
  </Link>
);

const Home = () => {
  useEffect(() => {
    AOS.init({ once: true, offset: 100 });
  }, []);

  return (
    <main className="min-h-screen w-full bg-gradient-to-br from-blue-100 to-white p-6">

      {/* Hero Section */}
      <section
  className="relative text-white rounded-2xl shadow-2xl mb-12 h-[450px] flex items-center justify-center overflow-hidden"
  data-aos="fade-up"
  data-aos-duration="1000"
>
  {/* Background Image with Gradient Overlay */}
  <div className="absolute inset-0">
    <img
      src="/admin.jpg"
      alt="Background"
      className="w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
  </div>

  {/* Content with Frosted Glass */}
  <div className="relative z-10 text-center px-6 sm:px-8 py-8 sm:py-10 bg-white/10 backdrop-blur-sm rounded-2xl shadow-xl max-w-3xl">
    <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold mb-4 sm:mb-6 drop-shadow-lg leading-snug">
      Welcome to <span className="text-blue-400">SVU Student Portal</span>
    </h1>
    <p className="text-sm sm:text-base md:text-lg lg:text-xl font-light text-gray-200 mb-6 sm:mb-8">
      Simplify your academic life with easy access to{" "}
      <span className="font-semibold text-blue-300">syllabus, notes, circulars</span>, 
      and university updates – all in one place.
    </p>
    <Link
      to="/about-svu"
      className="inline-block bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold px-6 sm:px-8 md:px-10 py-3 sm:py-4 rounded-xl shadow-lg hover:shadow-blue-500/50 transition-transform transform hover:scale-110"
    >
      Learn More About Us
    </Link>
  </div>
</section>




      {/* Informational Header */}
      <header
        className="text-center my-10"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <p className="mt-4 text-lg text-gray-700 max-w-2xl mx-auto">
          Your one-stop destination for syllabus, notes, circulars, and the latest university updates.
        </p>
      </header>

      {/* Card Features */}
      <section
        className="grid gap-8 md:grid-cols-3 max-w-6xl w-full px-4"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <Card
          to="/card1"
          title="Access Notes & PDFs"
          emoji="📚"
          description="Download organized study materials, lab manuals, and notes semester-wise."
        />
        <Card
          to="/card2"
          title="View Syllabus"
          emoji="🗂️"
          description="Quickly access the syllabus for each subject based on your department and semester."
        />
       <Card
  to="/announcements"
  title="Latest Circulars"
  emoji="📢"
  description="Stay updated with important notices, exam timetables, and official university announcements."
  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
/>



      </section>

      {/* Smart Features Section */}
      <section
        className="mt-12 text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <h3 className="text-2xl font-bold text-blue-800">Smart Features</h3>
        <p className="mt-2 text-gray-700 max-w-xl mx-auto">
          Use the AI-powered File Search Bot, Recent Uploads, and Student Uploads to enhance your learning experience.
        </p>
      </section>
    </main>
  );
};

export default Home;
